import React, { useEffect } from "react";
import { Box, Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import usePendingPaymentRecovery from "../hooks/usePendingPaymentRecovery";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { paymentAlert } = usePendingPaymentRecovery({
    onSuccess: async (data) => {
      const destination =
        data?.payment_type === "wallet_funding"
          ? "/account/authmenu/account/wallets"
          : "/account/authmenu/account/tickets";

      navigate(destination, { replace: true });
    }
  });

  useEffect(() => {
    if (!paymentAlert) {
      return;
    }

    if (paymentAlert.severity === "error") {
      const timeoutId = window.setTimeout(() => {
        navigate("/account/authmenu/account/tickets", { replace: true });
      }, 2500);

      return () => window.clearTimeout(timeoutId);
    }

    return undefined;
  }, [navigate, paymentAlert]);

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff"
      }}
    >
      <Stack spacing={2} alignItems="center" sx={{ width: "100%", maxWidth: 480 }}>
        {!paymentAlert ? <CircularProgress sx={{ color: "#ffb300" }} /> : null}
        <Typography variant="h5" fontWeight={700}>
          Verifying Payment
        </Typography>
        <Typography sx={{ opacity: 0.8, textAlign: "center" }}>
          Please wait while we confirm your transaction and complete the next step.
        </Typography>
        {paymentAlert ? (
          <Alert severity={paymentAlert.severity} sx={{ width: "100%" }}>
            {paymentAlert.text}
          </Alert>
        ) : null}
      </Stack>
    </Box>
  );
}
